<div class="wrapper">
    <div class="overlay" *ngIf="loading">
        <div class="spinner-wrapper">
            <mat-progress-spinner color="primary" mode="indeterminate" diameter="100"></mat-progress-spinner>
            <div class="loading-label-wrapper">
                <div class="loading-label">Loading...</div>
            </div>
        </div>
    </div>

    <div class="loaded-content" [class.blurred]="loading">
        <ng-content></ng-content>
    </div>
</div>